export const gender = ['male', 'female', 'other'];